import React from 'react'
import CommonSharedFileList from '../../../common/pages/secure/SharedFileList'
import Config from '../../../Config'
import Window from '../../../common/Window'

class SharedFileList extends CommonSharedFileList {
  constructor (props) {
    super(props)
    this.apiUrl = Config.adminApiUrl.systemSettings
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'add':
        this.props.history.push('/admin/shared_files/add')
        break
      default:
        break
    }
  }
  renderPageNavi () {
    return (
      <section className='nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span8'>
              <header className='page-header'>
                <h3>事務局からの共有ファィル一覧<br />
                  <small>こちらから事務局からの共有ファィルを管理できます。</small>
                </h3>
              </header>
            </div>
            <div className='span8'>
              <ul className='nav nav-pills'>
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='新規のお知らせを登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                    <i className='icon-plus icon-large' /><br /><span>新規</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    )
  }
  onCategoryEditButtonClicked (action, e) {
    e.preventDefault()
    switch (action) {
      case 'enter' :
        this.setState({
          targetCategory: '',
          isEditingCategory: true
        })
        break
      case 'save' :
        this.saveSharedFileCategory()
        break
      case 'cancel' :
        this.setState({
          targetCategory: '',
          isEditingCategory: false
        })
        this.load('SharedFileCategorySetting')
        break
      default:
        break
    }
  }
  changeCategoryName (offset, e) {
    e.preventDefault()
    const SharedFileCategorySetting = this.state.SharedFileCategorySetting.slice()
    if (SharedFileCategorySetting[offset].id === 'default') {
      Window.alert(SharedFileCategorySetting[offset].name + 'は変更することはできません。')
      return false
    }
    SharedFileCategorySetting[offset].name = e.target.value
    this.setState({
      SharedFileCategorySetting: SharedFileCategorySetting
    })
  }
  saveSharedFileCategory () {
    const SharedFileCategorySetting = this.state.SharedFileCategorySetting.slice()
    const errorIndex = []
    SharedFileCategorySetting.forEach((category, index) => {
      if (category.name.trim() === '') {
        errorIndex.push(index + 1)
      }
    })
    if (errorIndex.length > 0) {
      Window.alert(errorIndex.join('、') + '番目のカテゴリが空です。\nカテゴリ名は必須です。')
      return false
    }
    this.saveCategory()
  }
  onInsert (offset) {
    offset = Number(offset)
    const SharedFileCategorySetting = this.state.SharedFileCategorySetting.slice()
    SharedFileCategorySetting.splice(offset + 1, 0,
      {
        id: this.uuid(),
        name: ''
      }
    )
    this.setState({
      SharedFileCategorySetting: SharedFileCategorySetting
    })
  }
  onDelete (offset) {
    offset = Number(offset)
    const categoryId = this.state.SharedFileCategorySetting[offset].id
    if (categoryId === 'default') {
      Window.alert('「' + this.state.SharedFileCategorySetting[offset].name + '」は、削除することはできません。')
      return false
    }
    const sharedFileCountInThisCategory = this.state.SharedFileSetting.filter((e) => e.categoryId === categoryId).length
    if (sharedFileCountInThisCategory > 0) {
      Window.alert('「' + this.state.SharedFileCategorySetting[offset].name + '」は空でないため削除できません。\n共有ファイルを別のカテゴリに移動し、先にこのカテゴリを空にしてください。')
      return false
    }
    let message = 'このカテゴリーを削除してもよろしいですか?'

    if (this.state.SharedFileCategorySetting.length > 1) {
      Window.confirm(message, () => {
        const SharedFileCategorySetting = this.state.SharedFileCategorySetting.slice()
        SharedFileCategorySetting.splice(offset, 1)
        this.setState({
          SharedFileCategorySetting: SharedFileCategorySetting
        })
      })
    }
  }
  onMoveUp (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const SharedFileCategorySetting = this.state.SharedFileCategorySetting.slice()
      SharedFileCategorySetting.splice(offset - 1, 2, SharedFileCategorySetting[offset], SharedFileCategorySetting[offset - 1])
      this.setState({
        SharedFileCategorySetting: SharedFileCategorySetting
      })
    }
  }
  onMoveDown (offset) {
    offset = Number(offset)
    if (offset < this.state.SharedFileCategorySetting.length - 1) {
      const SharedFileCategorySetting = this.state.SharedFileCategorySetting.slice()
      offset++
      SharedFileCategorySetting.splice(offset - 1, 2, SharedFileCategorySetting[offset], SharedFileCategorySetting[offset - 1])
      this.setState({
        SharedFileCategorySetting: SharedFileCategorySetting
      })
    }
  }
  renderCategoryListToEdit () {
    const categoryEditor = this.state.SharedFileCategorySetting.map((category, index) => {
      return (
        <tr key={'edit' + category.id}>
          <td>
            <input type='text' value={category.name} onChange={(e) => this.changeCategoryName(index, e)} style={category.id === 'default' ? {backgroundColor: '#cccccc'} : {}} />
          </td>
          <td className='kw-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={(e) => this.onInsert(index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={index === 0 ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={(e) => this.onMoveUp(index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={(e) => this.onDelete(index)}
              style={(this.state.SharedFileCategorySetting.length <= 1 || category.id === 'default') ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={index === this.state.SharedFileCategorySetting.length - 1 ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={(e) => this.onMoveDown(index)} /></span>
          </td>
        </tr>
      )
    })
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>カテゴリ</li>
        <li className='text-center'>
          <button className='btn btn-small btn-primary' onClick={(e) => this.onCategoryEditButtonClicked('save', e)}><i className='icon-edit' />ｶﾃｺﾞﾘｰの変更を保存</button>
          <button className='btn btn-small bton-default' onClick={(e) => this.onCategoryEditButtonClicked('cancel', e)}><i className='icon-edit' />変更を保存せずに終了</button>
          <hr />
        </li>
        <li>
          <table className='kw-category-input-tbl'>
            <tbody>
              {categoryEditor}
            </tbody>
          </table>
        </li>
      </ul>
    )
  }
  renderCategoryListToShow () {
    const sharedFileCategorySelector = this.renderSharedFileCategorySetting(this.state)
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>カテゴリ<span className='pull-right'>
          <a onClick={(e) => this.onCategoryEditButtonClicked('enter', e)}><i className='icon-edit' />「ｶﾃｺﾞﾘｰ」を編集</a>
        </span></li>
        <li className={this.state.targetCategory === '' ? 'active' : ''} onClick={(e) => this.selectCategory('')}>
          <a id='view-all'>
            <i className='icon-chevron-right pull-right' />
            <b>全てのカテゴリを表示</b>
          </a>
        </li>
        {sharedFileCategorySelector}
      </ul>
    )
  }
  renderCategoryListBox () {
    return this.state.isEditingCategory ? this.renderCategoryListToEdit() : this.renderCategoryListToShow()
  }
}

export default SharedFileList



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SharedFileList.js